import { ResultObj, allFetch } from "../Domain";


export type MealPlaceDetailType = {
    mp_No: string;
    Name: string;
    Remark: string;
    mpg_id: string;
    customer_id: string;
    om_id: string;
}

export enum PrintContentEnum {
    detail = "detail",
    qrcode = "qrcode",
    close = "close",
}

/**
 * 列印設定
 * @param {string} printer_ip 列印API的IP
 * @param {string} printer_port 列印API的Port
 * @param {PrintContentEnum[]} print_after_create 新建訂單之後的列印內容
 * @param {PrintContentEnum[]} print_after_edit 修改訂單之後的列印內容
 * @param {PrintContentEnum[]} only_print 直接列印列印內容
 */
export type PrinterSetType = {
    printer_ip: string;
    printer_port: string;
    print_after_create: PrintContentEnum[],
    print_after_edit: PrintContentEnum[],
    only_print: PrintContentEnum[]
}

/**
 * @param {*} mpg_id 餐點場地類別流水號
 * @param {*} mp_No 餐點場地編號
 * @param {*} isUsing 是否使用中
 * @param {*} Name 名稱
 * @param {*} Plant 廠區
 */
export interface MealPlaceDetailReadParams {
    mpg_id: string;
    mp_No: string;
    isUsing: string;
    Name: string;
    Plant: string;
}

/**
 * 樓層資訊
 * @param {string} epson_print_set 列印設定字串格式
 * @param {string} epson_print_set_obj 列印設定物件格式
 */
export interface MealPlaceDetailDt {
    Cre_Time: string;
    Cre_Userid: string;
    Plant: string;
    Remark: string;
    Upd_Time: string;
    Upd_Usercre_time: string;
    Upd_Userid: string;
    Upd_Username: string;
    epson_print_set: string;
    epson_print_set_obj: PrinterSetType;
    mpg_id: string;
    mpg_name: string;
}

/**
 * 樓層座位資訊
 */
export interface MealPlaceDetailDtD {
    Name: string;
    Plant: string;
    Remark: string;
    Status: string;
    Upd_Time: string;
    Upd_Userid: string;
    Upd_Username: string;
    Upd_cre_time: string;
    company_code: string;
    cus_cre_time: string;
    customer_id: string;
    customer_name: string;
    customer_type: string;
    driver_name: string;
    mp_No: string;
    mp_id: string;
    mp_id_des: string;
    mpg_Name: string;
    mpg_id: string;
    om_id: string;
    sit_in_time: string;
}

export interface MealPlaceDetailReadResItem {
    Dt: MealPlaceDetailDt[],
    DtD: MealPlaceDetailDtD[]
}

/**
 * @description 取得餐點場地類別
 * @param {MealPlaceDetailReadParams} obj
 * @returns {Promise<ResultObj>}
 */
export const MealPlaceDetailRead = async (obj: MealPlaceDetailReadParams): Promise<ResultObj<MealPlaceDetailReadResItem>> =>
    await allFetch('MealPlaceDetail/Read', obj);


export interface MealPlaceDetailCreateParams {
    Plant: string;
    List: MealPlaceDetailType[];
}

/**
 * @description 新增樓層座位
 * @param {MealPlaceDetailCreateParams} obj
 * @returns {Promise<ResultObj>}
 */
export const MealPlaceDetailCreate = async (obj: MealPlaceDetailCreateParams): Promise<ResultObj> =>
    await allFetch('MealPlaceDetail/Create', obj);

/**
 * @param {*} mp_id 餐點場地流水號
 */
export interface MealPlaceDetailDeleteParams {
    mp_id: string;
}

/**
 * @description 刪除樓層座位
 * @param {MealPlaceDetailDeleteParams} obj
 * @returns {Promise<ResultObj>}
 */
export const MealPlaceDetailDelete = async (obj: MealPlaceDetailDeleteParams): Promise<ResultObj> =>
    await allFetch('MealPlaceDetail/Delete', obj);
